import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constant } from '../common/constant';

@Injectable()
export class NotificationService {

    constructor(private readonly http: HttpClient) {
    }

    getAllNotificationByResidentId(params, searchBy, accountId, residentId) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.GET_ALL_NOTIFICATION
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy
        + '&residentId=' + residentId + '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllNotificationByStaffId(params, searchBy, accountId, staffId) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.GET_ALL_STAFF_NOTIFICATION
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy
        + '&staffId=' + staffId + '&accountId=' + accountId;
        return this.http.get(url);
    }

    changeNotificationStatus(notificationId, status , rejectReason) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.CHANGE_NOTIFICATION_STATUS
        + '?notificationId=' + notificationId + '&Status=' + status + '&rejectReason=' + rejectReason;
        return this.http.get(url);
    }

    getAllDeviceNotification(params, searchBy, accountId, username) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.GET_DEVICE_NOTIFICATION
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy
        + '&username=' + username + '&accountId=' + accountId;
        return this.http.get(url);
    }

    getPanicNotification(params, searchBy, accountId) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.GET_PANIC_NOTIFICATION
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy
        + '&accountId=' + accountId;
        return this.http.get(url);
    }

    sendPanicNotification(details) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.SEND_PANIC_NOTIFICATION;
        return this.http.post(url , details);
    }

    getPanicNotificationCount(accountId,userMasterId){
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.GET_PANIC_NOTIFICATION_COUNT +
         '?accountId=' + accountId + '&userMasterId=' + userMasterId;
        return this.http.get(url);
    }

    changeStatusPanicNotifiaction(accountId,userMasterId){
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.CHANGE_PANIC_NOTIFICATION_STATUS +
         '?accountId=' + accountId +'&userMasterId=' + userMasterId;
        return this.http.get(url);
    }
}
